import { useAuthStore } from '@/stores/authStore';

/**
 * Hook to check if positive behaviors feature is enabled for the current school.
 * Returns true if enabled, false if disabled (default).
 *
 * When positive behaviors are enabled:
 * - Categories can be marked as positive (isPositive toggle in category form)
 * - Reports show separate sections for incidents vs recognitions
 * - Teacher logging shows visual distinction for positive categories
 * - Parent portal shows separate "Recognitions" section
 */
export function usePositiveBehaviorsEnabled(): boolean {
  const tenant = useAuthStore((state) => state.tenant);
  return tenant?.settings?.positiveBehaviorsEnabled === true;
}
